import { serviceRoles } from "config/access";
import { EVENT_TYPES } from "constants/routes";
import { checkAccess } from "helpers/auth";
import EnrollmentPage from "./container/EventTypePage";

export default function getRoute(userAuth) {
  const { account, calendy } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [calendy.name]: [calendy.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: EVENT_TYPES,
    withSidebar: true,
    withAppBar: true,
    component: EnrollmentPage,
  };
}
